export type Heading = {
  key: string;
  name: string;
  order: number;
  sections: any[];
};

export function buildHeadings(sections: any[] = [], groups: any = {}): Heading[] {
  const byKey: Record<string, Heading> = {};

  sections.forEach((section) => {
    if (!section || !section.parent) return;

    const key = section.parent;

    if (!byKey[key]) {
      const group = groups[key] || {};
      byKey[key] = { key, name: group.name || key, order: group.order || 0, sections: [] };
    }

    byKey[key].sections.push(section);
  });

  return Object.keys(byKey)
    .map((key) => ({
      ...byKey[key],
      sections: byKey[key].sections.sort((a, b) => (a.order || 0) - (b.order || 0))
    }))
    .sort((a, b) => a.order - b.order);
}

export function initialOpenHeadings(headings: Heading[] = []): Record<string, boolean> {
  const relevant = headings.filter((heading) =>
    heading.sections.some((section) => section.mostRelevant)
  );
  const open = relevant.length > 0 ? relevant : headings.slice(0, 1);

  return headings.reduce((acc: Record<string, boolean>, heading) => {
    acc[heading.key] = open.indexOf(heading) > -1;
    return acc;
  }, {});
}

export function headingFieldCount(heading: Heading): number {
  return heading.sections.reduce(
    (total, section) => total + ((section.attributes && section.attributes.length) || 0),
    0
  );
}
